Object.defineProperty(exports, "__esModule", {
  value: true
});

var _v = require('uuid/v4');

var _v2 = _interopRequireDefault(_v);

var _Tracking = require('./Tracking');

var _Tracking2 = _interopRequireDefault(_Tracking);

var _rum = require('./rum');

var _rum2 = _interopRequireDefault(_rum);

var _scrollDepth = require('./scrollDepth');

var _scrollDepth2 = _interopRequireDefault(_scrollDepth);

var _trackEmailReferrer = require('./trackEmailReferrer');

var _trackEmailReferrer2 = _interopRequireDefault(_trackEmailReferrer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var MAX_RETRIES = 3; /* globals XMLHttpRequest */

/*
 * Tracking
 * -----------------------------
 * Use Tracking to initialize different trackers.
 *
 * The trackers should live in their own files, not in this one.
 *
 * For trackers to send or initialize data, add an init hook using
 * Tracking.addInitHook().
 *
 * All tracker initializers will be run upon Tracking.init().
 * if init() already ran, the initializer will run immediately
 * upon passing to addInitHook().
 *
 */

var TIMEOUT_MS = 10000;

function request(originalData) {
  var retryCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  var path = void 0;
  var data = Array.isArray(originalData) ? originalData : [originalData];

  var jitneyEvents = data.filter(function (d) {
    return d.schema;
  });
  var airEvents = data.filter(function (d) {
    return !d.schema;
  });

  if (airEvents.length > 0 && jitneyEvents.length > 0) {
    return Promise.all([request(airEvents), request(jitneyEvents)]);
  }

  if (airEvents.length > 0) {
    data = airEvents;
  } else if (jitneyEvents.length > 0) {
    data = jitneyEvents;
  } else {
    // No data to send
    return Promise.resolve();
  }

  if (data[0].schema) {
    // This is a Jitney event or Jitney batch, so we use the Jitney endpoint
    path = '/tracking/jitney/logging/messages';

    // Jitney pipeline requires a client-generated uuid.
    // Avoid regenerating uuid if it already exists, e.g. on retry
    data = data.map(function (event) {
      return Object.assign({}, event, {
        uuid: event.uuid || (0, _v2['default'])()
      });
    });
  } else {
    path = '/tracking/events';
  }

  return new Promise(function (resolve, reject) {
    var req = new XMLHttpRequest();
    req.open('POST', path);
    req.setRequestHeader('Content-type', 'application/json');
    req.onload = function () {
      // Status code 1223 required for pre-IE10 bug:
      // http://blogs.msdn.com/b/ieinternals/archive/2009/07/23/the-ie8-native-xmlhttprequest-object.aspx
      if (req.status >= 200 && req.status <= 204 || req.status === 1223) {
        resolve();
      } else {
        reject({
          status: req.status,
          responseText: req.responseText
        });
      }
    };
    req.onerror = function () {
      reject({
        status: req.status,
        responseText: req.responseText
      });
    };

    req.timeout = TIMEOUT_MS;
    req.ontimeout = function () {
      if (retryCount >= MAX_RETRIES) {
        reject({ timeout: TIMEOUT_MS });
      } else {
        // recursive retry
        var nextRetryCount = retryCount + 1;
        var retryData = data.map(function (event) {
          return Object.assign({}, event, {
            event_data: Object.assign({}, event.event_data, {
              trackingjs_retry_count: nextRetryCount
            })
          });
        });

        var retryRequest = request(retryData, nextRetryCount);

        retryRequest.then(resolve)['catch'](reject);
      }
    };

    req.send(JSON.stringify(data));
  });
}

var instance = new _Tracking2['default']({
  logger: { request: request }
});

// Require each of the sub-trackers, which will attach themselves to the `Tracking` instance.
(0, _scrollDepth2['default'])(instance);

instance.addInitHook(function () {
  return (0, _trackEmailReferrer2['default'])(instance);
});

// TODO(lmr):
instance.addInitHook(function () {
  if (instance.options.rum === true) {
    instance.rum = (0, _rum2['default'])(instance);
  }
});

exports['default'] = instance;


//////////////////
// WEBPACK FOOTER
// ./~/airbnb-tracking/build/index.client.js
// module id = 475
// module chunks = 168707334958949